import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { ProjectStatus } from '@awork/features/project/models/project-status.model'

@Injectable({ providedIn: 'root' })
export class ProjectStatusStore extends EntitySignalStore<ProjectStatus> {
  constructor() {
    super({
      name: 'projectStatus',
      entityConstructor: projectStatus => new ProjectStatus(projectStatus),
      nullableProps: ['order', 'typeOrder', 'projectId', 'projectTemplateId', 'workflowId']
    })
  }
}
